import React from "react";
import Head from "next/head";

const NoIndexHeader = () => (
    <Head>
        <meta name="robots" content="noindex, nofollow" />
    </Head>
);

export default NoIndexHeader;
